import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { AccountId } from 'caip';
export function normalizeAccountId(accountId) {
  if (typeof accountId === 'string' && accountId.includes('@')) {
    var _accountId$split = accountId.split('@'),
      _accountId$split2 = _slicedToArray(_accountId$split, 2),
      address = _accountId$split2[0],
      chainId = _accountId$split2[1];
    if (!address || !chainId) {
      throw new Error("Invalid accountId provided");
    }
    return new AccountId({
      address: address,
      chainId: chainId
    });
  }
  return new AccountId(accountId);
}
export function toLegacyAccountId(accountId) {
  if (!accountId.includes('@')) {
    var _accountSplit = accountId.split(':');
    var address = _accountSplit.pop();
    var chainId = _accountSplit.join(':');
    return "".concat(address, "@").concat(chainId);
  }
  return accountId;
}